/**
 * Product comparison data — 產品比較頁假資料（prototype）
 *
 * 代表性假資料：3 個玻尿酸填充劑產品 × 規格矩陣（比較上限 3，對齊 compare-bar.js MAX_SLOTS）。
 * - products[]：被比較的產品清單（順序 = 比較表欄位 A/B/C 順序）
 * - specRows[]：規格項目（比較表的「列」），每列定義一個 key + 顯示標題 + 型別
 *     type: 'text'    — 直接顯示字串值
 *     type: 'bool'    — true 顯示 check icon、false 顯示 dash
 *     type: 'verified'— true 顯示綠勾 + visibleLabel 文字（如「已驗證」）；
 *                       與 bool 的差異＝這列把意義文字「可見」呈現（非僅螢幕報讀），
 *                       供「平台審核」這類需露出狀態標記的列使用。
 *   每個 product.specs[key] 對應該列的值。
 *
 * 待接 backend：上線後改為 fetch from CMS；化名僅供 prototype，勿視為真實品牌主張。
 * 圖片沿用既有 /images/categories/*.jpg（產品縮圖佔位）。
 *
 * DEMO: 示意資料，正式資料待客戶/後端（品牌、產地、交聯技術、核准狀態、價格、評分皆 demo 佔位）。
 * 對應資料模型：Product（比較表維度：evidenceLevel / auditScore / reversible / tfda / crosslink 等）。
 *   ⚠ 產品管理屬山川 CMS，後端多半只讀不寫。欄位定義見 docs/handoff/HANDOFF_BACKEND.md §5 資料模型。
 */

export const COMPARE_SPEC_ROWS = [
  { key: 'category', label: '產品類型', type: 'text' },
  { key: 'region', label: '產地', type: 'text' },
  { key: 'crosslink', label: '交聯技術', type: 'text' },
  { key: 'tfda', label: '衛福部核准', type: 'bool', boolYes: '已核准', boolNo: '未核准' },
  { key: 'evidenceLevel', label: '證據分級', type: 'text' },
  { key: 'duration', label: '效果持續時間', type: 'text' },
  { key: 'application', label: '主要適用部位', type: 'text' },
  { key: 'reversible', label: '可酵素溶解', type: 'bool', boolYes: '可酵素溶解', boolNo: '不可酵素溶解' },
  { key: 'auditScore', label: '平台審核', type: 'verified', visibleLabel: '已驗證' },
  { key: 'priceRange', label: '參考價格區間', type: 'text' },
];

// demo·待客戶後台補真實資料（品牌、產地、交聯技術、核准狀態、效果時間、價格、評分皆為 demo 佔位）
export const COMPARE_PRODUCTS = [
  {
    id: 'ha-juvederm',
    name: 'Juvederm 喬雅登',
    vendor: '美系 · Allergan',
    img: 'category-1.jpg',
    alt: 'Juvederm 喬雅登 玻尿酸填充劑',
    href: 'product-detail.html',
    highlight: 'VYCROSS 高交聯技術，支撐力佳',
    specs: {
      category: '玻尿酸',
      region: '美國',
      crosslink: 'VYCROSS',
      tfda: true,
      evidenceLevel: 'VE · 實證審核章',
      duration: '12–18 個月',
      application: '中臉 / 蘋果肌',
      reversible: true,
      auditScore: true,
      priceRange: 'NT$ 18,000 – 28,000',
    },
  },
  {
    id: 'ha-restylane',
    name: 'Restylane 瑞斯朗',
    vendor: '歐系 · Galderma',
    img: 'category-2.jpg',
    alt: 'Restylane 瑞斯朗 玻尿酸填充劑',
    href: 'product-detail.html',
    highlight: 'NASHA 穩定化技術，全球使用最廣',
    specs: {
      category: '玻尿酸',
      region: '瑞典',
      crosslink: 'NASHA',
      tfda: true,
      evidenceLevel: 'VE · 實證審核章',
      duration: '9–12 個月',
      application: '淚溝 / 唇部',
      reversible: true,
      auditScore: true,
      priceRange: 'NT$ 16,000 – 24,000',
    },
  },
  {
    id: 'ha-neuramis',
    name: 'Neuramis 紐拉密斯',
    vendor: '韓系 · Medytox',
    img: 'category-3.jpg',
    alt: 'Neuramis 紐拉密斯 玻尿酸填充劑',
    href: 'product-detail.html',
    highlight: 'SHAPE 技術，性價比取向',
    specs: {
      category: '玻尿酸',
      region: '韓國',
      crosslink: 'SHAPE',
      tfda: true,
      evidenceLevel: 'CI · 議題洞察章',
      duration: '6–9 個月',
      application: '法令紋 / 全臉',
      reversible: true,
      auditScore: true,
      priceRange: 'NT$ 9,000 – 16,000',
    },
  },
];
